export enum QuestionType {
	multipleChoice = 1,
	textField = 2,
	singleChoice = 3,
}
